import { render, staticRenderFns } from "./BB_JobAds.vue?vue&type=template&id=11d98848&scoped=true&"
import script from "./BB_JobAds.vue?vue&type=script&lang=js&"
export * from "./BB_JobAds.vue?vue&type=script&lang=js&"
import style0 from "./BB_JobAds.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./BB_JobAds.vue?vue&type=style&index=1&id=11d98848&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "11d98848",
  null
  
)

export default component.exports